"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _smalt = require("@airportlabs/smalt");
var _jsTools = require("@airportlabs/js-tools");
var _ConnectionStatus = _interopRequireDefault(require("./ConnectionStatus"));
var _authType = require("./auth/authType");
var _clientLinks = require("./clientLinks");
var _index = require("./auth/index");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var propTypes = {
  client: _propTypes["default"].object,
  children: _propTypes["default"].node,
  wsDebug: _propTypes["default"].bool,
  // Whether the absence of a REFRESH_TOKEN (or an ACCESS_TOKEN for simple auth)
  // should redirect to login. Useful for iam-login-ui which doesn't want to
  // redirect to itself.
  requireToken: _propTypes["default"].bool
};
var TOKEN_PARAM = "token";
_jsTools.envConsole.groupCollapsed("REACT_APP env variables");
_jsTools.envConsole.fn(function () {
  (0, _forEach["default"])((0, _jsTools.getReactEnv)(), function (value, key) {
    console.log("".concat(key, ": \"").concat(value, "\""));
  });
});
_jsTools.envConsole.groupEnd();
var AUTH_TYPE = (0, _authType.getAuthType)();
var redirectIfMissingToken = function redirectIfMissingToken() {
  return AUTH_TYPE === _authType.authTypes.SIMPLE ? (0, _index.redirectToLoginIfNoAccessToken)().isTokenMissing : (0, _index.redirectToLoginIfNoRefreshToken)().isTokenMissing;
};
var CustomApolloProvider = function CustomApolloProvider(_ref) {
  var client = _ref.client,
    children = _ref.children,
    _ref$requireToken = _ref.requireToken,
    requireToken = _ref$requireToken === void 0 ? true : _ref$requireToken,
    wsDebug = _ref.wsDebug;
  requireToken = AUTH_TYPE !== _authType.authTypes.NONE && requireToken;
  var _useState = (0, _react.useState)(!requireToken),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isTokenLoaded = _useState2[0],
    setIsTokenLoaded = _useState2[1];
  (0, _react.useEffect)(function () {
    var searchParams = new URLSearchParams(window.location.search);
    var token = searchParams.get(TOKEN_PARAM);
    if (!token && requireToken) {
      var isMissing = redirectIfMissingToken();
      setIsTokenLoaded(!isMissing);
      return;
    } else if (token) {
      var persistFn = AUTH_TYPE === _authType.authTypes.SIMPLE ? _index.persistAccessToken : _index.persistRefreshToken;
      persistFn(token);
      searchParams["delete"](TOKEN_PARAM);
      window.location.href = window.location.pathname + (searchParams.toString().length ? "?" + searchParams.toString() : "");
      setIsTokenLoaded(true);
    }
  }, [requireToken]);
  if (requireToken && !isTokenLoaded) {
    return /*#__PURE__*/_react["default"].createElement(_smalt.LoaderFull, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_client.ApolloProvider, {
    client: client
  }, (0, _jsTools.getEnv)("NODE_ENV") === "development" && wsDebug && /*#__PURE__*/_react["default"].createElement(_ConnectionStatus["default"], {
    subscriptionClient: _clientLinks.graphqlWsLink.client
  }), children);
};
CustomApolloProvider.propTypes = propTypes;
var _default = exports["default"] = CustomApolloProvider;